<template>
  <campsite-notices-subsection
    :warnings="warnings"
    :notices="notices"
    :notices-needs-translation="noticesNeedsTranslation"
    :campsite-notices="campsiteNotices"
    :restrictions="restrictions"
    :bring-bed-linen="bringBedLinenHtml"
  >
    <ul v-if="restrictions">
      <li v-for="(restriction, index) in restrictions" :key="index">
        <img
          loading="lazy"
          src="@/assets/images/exclamation-mark-blue.svg"
          width="18"
          height="18"
          alt=""
        />{{ restriction.name }}
      </li>
    </ul>

    <ul v-if="bringBedLinenHtml">
      <li>
        <img
          loading="lazy"
          src="@/assets/images/exclamation-mark-blue.svg"
          width="18"
          height="18"
          alt=""
        />
        <div v-thtml="bringBedLinenHtml" class="preserve-linebreaks" />
      </li>
    </ul>
  </campsite-notices-subsection>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { CampsiteNotices } from '../../campsite-details/types'

@Component
class BookingNotices extends Vue {
  @Prop()
  notices: string

  @Prop()
  campsiteNotices: CampsiteNotices[]

  @Prop({ default: () => [] })
  warnings: string[]

  @Prop()
  bringBedLinenHtml: string

  @Prop()
  restrictions: Array<{
    amenityIcon: string
    name: string
  }>

  @Prop({ default: false })
  noticesNeedsTranslation: boolean
}

export default toNative(BookingNotices)
</script>
<style scoped>
.notices {
  padding: 0;
  border-bottom: none;
  margin: 0 0.8em;
}

.notices :deep(header) {
  margin: 0 0 0.5em 0;
}

.notices :deep(.subsection-content) {
  max-height: 2em;
}

.notices :deep(li) {
  font-size: var(--body);
}

.notices :deep(h2) {
  font-size: var(--large);
  font-weight: 600;
  color: var(--colour-wcag-blue);
  display: flex;
  align-items: center;
  gap: 0.35em;
}

.notices :deep(h2 img) {
  width: 1em;
}

.notices :deep(li) {
  margin: 0 0 0.7em;
  padding: 0 0 0 1.9em;
  position: relative;
}

.notices :deep(li img) {
  display: inline-block;
  position: absolute;
  left: 0.2em;
  width: 1.2em;
  height: 1.2em;
  filter: opacity(0.3) saturate(0.5);
}

.notices.desktop :deep(header) {
  margin: 0 0 0.8em 0;
}

.notices.desktop :deep(h2) {
  font-size: 1.4em;
}
</style>
